import styled, { createGlobalStyle } from "styled-components";
import hrarrow from "./assets/hrarrow.png";
import hlarrow from "./assets/hlarrow.png";

const GlobalStyle = createGlobalStyle`
  * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  } 
 body
{
  overflow-x: hidden !important;
   background: white !important;
  font-family: 'Barlow', sans-serif;
  font-family: 'Roboto', sans-serif;
}


@media (min-width: 992px)
  {
   .collectionContainer .filterRow .col-lg-10 {
    flex: 0 0 auto;
    width: 80% !important;
}
.collectionContainer .filterRow .col-lg-2 {
    flex: 0 0 auto;
    width: 18.5% !important;
}
  }


iframe
{
  position: absolute !important;
  width: none !important;
  top: none !important;
  left: none !important;
  right: none !important;
  z-index: -5 !important;
}
 .hideScreen {
    display: hidden !important;
  }
  .collectionContainer {
      /* max-width: 1177px !important; */
    }
.lazy-load-image-background.blur.lazy-load-image-loaded > img {
    border-radius: 20px 20px 0 0;
}
.main
  {
    min-height: calc(100vh - 72px - 50px);
  }

  .slick-list {
     
  }
  
.slick-arrow {
  display: none !important;
}
.slick-prev::before {
  display: none !important;
}

  .slick-next {
  background: url(${hrarrow}) center center no-repeat !important;
  display: none;

  @media (max-width: 1430.98px) { 
    visibility: hidden;
   }
}
.slick-next::before {
  display: none !important;
}

 .slick-prev {
  background: url(${hlarrow}) center center no-repeat !important;
  @media (max-width: 1430.98px) { 
    visibility: hidden;
   }
}

.slick-prev, .slick-next {
  width: 30px;
  height: 30px;
}

/* Slick */
  .slick-dots li button:before {
    font-size: 10px;
    margin-top: 2rem;


  }
@media (min-width: 1024px) {
  .slick-arrow {
    display: block !important;
  }
}
@media (min-width: 1440px) {
  .slick-list {
    margin: 0px -6px;
    color: white !important;
  }
  .slick-slide > div {
  }
} */

 
  
/* Collection  */
.ant-select-arrow {
 /* border:  none;
 color: white !important ;
 margin-top: -0.3rem; */
}  
.ant-collapse-content>.ant-collapse-content-box {
   /* background: #121619;
   color: white; */
  }
/* Collection  */
.trendingSection .ant-select:not(.ant-select-customize-input) .ant-select-selector {
 border:  none !important;
 background: #121619 ;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector 
{
 border:  none !important;

}
.ant-select-focused:not(.ant-select-customize-input) .ant-select-selector 

{
  outline: none !important;
   box-shadow: none !important;
}
 
.trendingSection .ant-select-arrow {
 border:  none !important;
 color: white !important ;
 
}  
.ant-select-focused:not(.ant-select-customize-input) .ant-select-selector {
     /* box-shadow: none !important; */
}
 .trendingSection .ant-select-selection-item
 {
  margin-top: 0.1rem !important;
 }
/* Models styles  */
.ant-modal-footer
  {
    display: none;
  }
  .ant-modal-close
  {
    display: none;
  }
  .ant-modal-content
  {
   background: none;
  }
  .ant-modal-body
  {
    padding: 0px;
  }
  .ant-modal-mask
  {
    background-color: rgb(0 0 0 / 78%) ;
  }
  .closeModelInput
  {
    transform: translateY(-2px);
  }
    .ant-space-align-baseline
  {
    display: flex;
    justify-content:center  ;
  }
  .modalInputMale
  {
    border-top-right-radius:7px;
  border-bottom-right-radius:7px;
  transform: translateX(-6px);
  }
  .ant-form-vertical .ant-form-item-label>label {
  
 
    font-weight:600;
}
  /* Models styles */


  /* ANT Design Collapseable */

  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    flex-direction: row-reverse;

    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    color: black;
    /* border: none !important; */
    /* border-radius: 0px 0px 10px 10px;
    border: 1px solid #333333; */
  
  }

  

  
  .ant-collapse-content {
 
    border-top: none;
}
 .ant-collapse>.ant-collapse-item>.ant-collapse-header .ant-collapse-arrow
 {
  
  margin-right: 0px !important;
 }
 .collectionContainer
 .ant-collapse>.ant-collapse-item>.ant-collapse-header .ant-collapse-arrow
 {
  
  margin-right: -12px !important;
 }
 
 .ant-collapse-content>.ant-collapse-content-box {
    color: black;

    
}

.ant-collapse>.ant-collapse-item:last-child, .ant-collapse>.ant-collapse-item:last-child>.ant-collapse-header {

  /* border-bottom: 1px solid #333333 !important; */
  /* border-radius: 0px 0px 10px 10px; */

}

.ant-collapse {
  border: none;

  

}


  /* ANT Design Collapseable */

//Divider 



/* Dashboard */
.navbarHeader {
  background-color: var(--navbarHeader);
  padding: "5px 0";
}
#components-layout-demo-custom-trigger .trigger {
 
  
  cursor: pointer !important;
  
  
    
}
  
.trigger {
  /* background-color: #3a6af1; */
  margin-left: 1rem;
  color: var(--triggerColor) !important;
  font-size: 1.5rem;
  margin-top: -0.2rem;
  margin-right: 0.5rem;
  padding: 20px 0 !important;
}
.ant-layout-sider-children {
  min-height: 10rem;
   
}
.ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
  width: auto;
  border-right: none;
}
.ant-layout-sider {
  background-color: var(--bgSidebar) !important;
  overflow-x: hidden !important;
  flex: 0 0 260px !important ;
  max-width: 270px !important;
  min-width: 220px !important; 
  z-index: 999; 
 }
 
.ant-menu.ant-menu-root {
  background-color: transparent;
  width: 15rem;
  margin-left: 0.5rem;
}
.ant-menu-item {
  font-size: 1rem !important;
  font-weight: 600;
  padding: 28px 30px !important;
  border-radius: 5px;
  color: var( --navbarMenuItem) !important;
  /* background-color: #1f1750 !important; */
}
.ant-menu-inline {
  border: none !important;
}
.ant-menu-item.ant-menu-item-selected {
  background-color: var(--navbarMenuActive) !important;
  color: var(--navbarMenuColor) !important;
}
.ant-menu-item.ant-menu-item-selected::after {
  transform: none !important;
  opacity: 0 !important;
}
/* .site-layout .site-layout-background {
  background: #1f1750 !important;
} */
.ant-menu-inline-collapsed > li {
  padding: 0 !important;
  width: 100%;
  height: 3rem !important;
}
.ant-layout-sider-collapsed {
  /* width: 120px !important; */
  flex: 0 0 98px !important ;
  max-width: 98px !important;
  min-width: 98px !important;
}
.ant-menu-inline-collapsed .ant-menu-item.ant-menu-item-selected {
  width: 80px;
}
.ant-menu-inline-collapsed .ant-menu-item-icon {
  margin-left: 1.8rem !important;
  margin-bottom: 3.5rem !important;
}
/* Ant SubMenu */
/* Collapsed Icon  */
.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-item-icon {
  margin-left: -6px !important; 
}
 
 
.ant-menu-submenu .ant-menu-vertical
{
  background-color: black!important;
  padding: 10px !important;
} 
.ant-menu-submenu .ant-menu-vertical .ant-menu-item 
 
{
    padding: -0px 25px !important;
}
 .ant-menu-submenu .ant-menu-vertical > li
{
    
   font-size: 1.1rem;
   /* width: 25rem; */
    
}  
.ant-menu-submenu .ant-menu-vertical   .ant-menu-submenu-title  .ant-menu-title-content
{
    
   font-size: 1.1rem;
  margin-top: -2rem !important;
   
 
    
}
 
 
.ant-menu-inline-collapsed .ant-menu-submenu {
  width: 80px !important;
   }
  
 
 
.ant-menu-submenu {
 
  margin-left: 3px !important;
   
}
.ant-menu.ant-menu-sub.ant-menu-inline {
  background-color: var(--navbarSubMenuBg) !important;
}
.ant-menu-submenu-title .ant-menu-title-content {
  color: var(--navbarSubMenuTitle) !important;
  font-size: 1.1rem !important;
  font-weight: 600;
}
.ant-menu-submenu-title .anticon-tags {
  color: var(--navbarSubMenuIcon) !important;
}
.ant-menu-submenu-arrow {
  color: var(--navbarSubMenuIcon) !important;
}
 
  .modelPopup
{
  margin-left: 51.5rem !important;
}
@media (min-width: 300px) {
  .antRes{
  
    display:none !important;
  }
    .ant-layout-sider-collapsed 
  {
    display: block !important;  
  }
}
@media (min-width: 600px) {
  .antRes    {
  
    display:block !important;
 } 
 .ant-layout-sider-collapsed.ant-layout-sider 
  {
    display: block !important;  
  }
}
:root {
  --bgContent: #fff;
  --navbarHeader: #fff;
  --bgColorSection: #E5F1EA;
  --navbarBtn:#0c8ded;
  --navbarMenuIcon: #1A1C23;
  --navbarMenuItem: #fff;
  --navbarMenuActive: #fff;
  --navbarSubMenuCollapsedActive: #fff;
  --navbarSubMenuBg: #1A1C23;
  --navbarSubMenuTitle: #fff;
  --navbarSubMenuIcon: #fff;
  --navbarMenuColor: #000;
  --triggerColor: #000;
  --bgSidebar:  #1A1C1E; /**for side bar*/
  --swapCardbg: #293443;
  --swapCardColor: #fff;
   
}
.contentx {
  background-color: var(--bgContent);
}
/* Dashboard */
/* Chartjs */
.recharts-wrapper
{
  width: 100% !important;
  height: 440px !important;
}
/* Expense Card */
.expenseCard
{
  margin-top: 2rem;
}
.recharts-default-legend
{
  margin-top:-12.5rem !important;
}
/* Header Dashboard */
.dashboardHeader.dropdown > a  {
    margin-left: 6.5rem !important;
  }
/* Dashboard close */
/* sidebar */
.sidebarCard .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    {
      font-weight: 600;
      padding: 1.2rem;
      /* border-top: 2px solid white; */
    }
 
  .filterIcon
  {
    font-weight: 600;
    font-size: 1.5rem;
    margin-right: 1rem;
  }
  
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
     
  /* margin-top: 0.4rem; */
}
.createCollecton  .ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  
  margin-top: 0rem;
}
.inputField
{
  margin-top: 1rem ;
}
 
.LinksInput
{
  margin-top: -1rem;
  background: transparent;
  color: black;
  padding: 0.7rem;
}
.LinksInput:focus
{
  color: black;
  background: transparent;
}
.LinksInput::placeholder
{
  color: white;
  opacity: 0.8;
  font-size: 12px;
}
.createCollecton  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
     margin-left: -0.2rem !important;
     
}
.sidebarCard .ant-select:not(.ant-select-customize-input) .ant-select-selector {
   border-radius: 10px;
   
}
.sidebarCard .ant-select-focused
{
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
}
.priceLowToHighSelect
{
  margin-left: 11rem !important;
}
.mainSection
{
  /* margin-left: -5rem; */
}
/* sidebar */
 
 
 
    @media (min-width: 1880px) {
      .lazyCardImage
      {
        width: 16.38rem;
      }
  }
  @media (max-width: 1840px) {
    .lazyCardImage
      {
        width: 19.7rem;
        
      }
  }
  @media (max-width: 1660px) {
    .lazyCardImage
      {
        width: 17.2rem;
        
      }
  }
  @media (max-width: 1660px) {
    .lazyCardImage
      {
        width: 16.8rem;
        
      }
  }
  @media (max-width: 1540px) {
    .lazyCardImage
      {
        
        width: 16rem;
      }
  }
  @media (max-width: 1496px) {
    .lazyCardImage
      {
        
        width: 15.7rem;
      }
  }
  @media (max-width: 1440px) {
    .lazyCardImage
      {
        
        width: 15.1rem;
      }
  }
  @media (max-width: 1280px) {
    .lazyCardImage
      {
        
        width: 16.7rem;
      }
  }
  @media (max-width: 1200px) {
    .lazyCardImage
      {
        
        width: 24rem;
      }
  }
  @media (max-width: 1180px) {
    .lazyCardImage
      {
        
        width: 19.5rem;
      }
  }
  @media (max-width: 1060px) {
    .lazyCardImage
      {
        
        width: 17.5rem;
      }
  }
  @media (max-width: 990px) {
    .lazyCardImage
      {
        
        width: 100%;
      }
  }
  
 
  
  /* Antd Upload */
  .ant-upload-list
  {
    display: flex ;
    flex-direction: column-reverse;
  }
 .userProfile .ant-upload-list-item , .createCollecton .ant-upload-list-item ,.profileSetting .ant-upload-list-item  {
    
    display: none;
}

.ant-btn:focus
{
  background: transparent !important;
}


  /* Nft Details */
  .nftDetails .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    {
      background: #fff;
    }
   
    /* acordian */
    .accordion-button:not(.collapsed) {
    color: #000;
    background-color: transparent !important;
    border: none;
    box-shadow: none !important;
  }
   
/* Navbar*/
 .meta-sphere-navbar  .navbar-toggler-icon {
  background-image: url(
    "data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
}  
 
/*Navbar  */
/* Collection-all  */
 
  /* Collection-all */

//swip



`;

export default GlobalStyle;
